export const dataUploadOptions = [{
  value: "file-upload",
  label: "File Upload",
  disabled: false
},
{
  value: "github-link",
  label: "Github Link",
  disabled: false
}
]

export const sourceOptions = [
  {
    label: "Source Architecture / Platform",
    options: [
      { value: "springBoot", label: "Spring Boot" },
      { value: "xamarin", label: "Xamarin" },
      { value: "powerBuilder", label: "Power builder" },
      { value: "pega", label: "Pega" },
      { value: "informix", label: "Informix" },
      { value: "mainframe", label: "Mainframe" },
      { value: "javaUpgrade", label: "Java Upgrade" },
      { value: "teradataBTEQ", label: "Teradata/BTEQ" },
      { value: "dotNetFramework", label: ".NET Framework" },
      { value: "aspNetMVC", label: "ASP.NET MVC" },
      { value: "dotNetCore", label: ".NET Core" }
    ]
  },
  {
    label: "Programming Language",
    options: [
      {
        value: "bteq",
        label: "BTEQ",
        language: "sql",
        extension: "txt, bteq"
      },
      {
        value: "COBOL",
        label: "COBOL",
        language: "fortran",
        extension: "txt, cbl, sub_routine, cob, cpy"
      },
      {
        value: "Java",
        label: "Java",
        disabled: false,
        extension: "txt, java"
      },
      {
        value: "SQL",
        label: "SQL",
        disabled: false,
        extension: "txt, sql"
      },
      {
        value: "python",
        label: "Python",
        disabled: false,
        extension: "txt, py"
      },
      {
        value: "C#",
        label: "C#",
        disabled: false,
        extension: "txt, cs"
      },
      {
        value: "C%2B%2B",
        label: "C++",
        disabled: false,
        extension: "txt, cpp, cc, cxx, h"
      },
      {
        value: "Rust",
        label: "Rust",
        disabled: false,
        extension: "txt, rs"
      },
      {
        value: "pyspark",
        label: "Pyspark",
        disabled: false,
        extension: "txt, py"
      },
      {
        value: "VB",
        label: "VB",
        disabled: false,
        extension: "txt, vb"
      },
      {
        value: "VB.NET",
        label: "VB.NET",
        disabled: false,
        extension: "txt, vb"
      },
      {
        value: "Power Builder",
        label: "Power Builder",
        disabled: false,
        extension: "txt, pbl, sra, sru, srw"
      },
      {
        value: "React",
        label: "React",
        disabled: false,
        extension: "txt, jsx, js, ts, tsx"
      },
      {
        value: "Angular",
        label: "Angular",
        disabled: false,
        extension: "txt, ts, html, css, scss"
      },
      {
        value: "MS Access",
        label: "MS Access",
        disabled: false,
        extension: "txt, accdb, mdb"
      }
    ]
  },
  {
    label: "Hyperscalers",
    options: [
      { value: "gcp", label: "GCP (Google Cloud Platform)" },
      { value: "aws", label: "AWS (Amazon Web Services)" },
      { value: "azure", label: "Azure" },
      { value: "onpremises", label: "On-premises" },
      { value: "ibm", label: "IBM Cloud" },
      { value: "oracle", label: "Oracle Cloud" },
      { value: "digitalOcean", label: "DigitalOcean" },
      { value: "heroku", label: "Heroku" },
      { value: "VMware", label: "VMware" },
      { value: "openStack", label: "OpenStack" },
      { value: "alibaba cloud", label: "Alibaba Cloud" },
      { value: "rackspace", label: "Rackspace" },
      { value: "salesforce", label: "Salesforce Platform" }
    ]
  }
];


export const targetOptions = [
  {
    label: "Source Architecture / Platform",
    options: [
      { value: "springBoot", label: "Spring Boot" },
      { value: "xamarin", label: "Xamarin" },
      { value: "powerBuilder", label: "Power builder" },
      { value: "pega", label: "Pega" },
      { value: "informix", label: "Informix" },
      { value: "mainframe", label: "Mainframe" },
      { value: "javaUpgrade", label: "Java Upgrade" },
      { value: "teradataBTEQ", label: "Teradata/BTEQ" },
      { value: "dotNetFramework", label: ".NET Framework" },
      { value: "aspNetMVC", label: "ASP.NET MVC" },
      { value: "dotNetCore", label: ".NET Core" }
    ]
  },
  {
    label: "Programming Language",
    options: [
      {
        value: "bteq",
        label: "BTEQ",
        language: "sql",
        extension: "txt, bteq"
      },
      {
        value: "COBOL",
        label: "COBOL",
        language: "fortran",
        extension: "txt, cbl, sub_routine, cob, cpy"
      },
      {
        value: "Java",
        label: "Java",
        disabled: false,
        extension: "txt, java"
      },
      {
        value: "SQL",
        label: "SQL",
        disabled: false,
        extension: "txt, sql"
      },
      {
        value: "python",
        label: "Python",
        disabled: false,
        extension: "txt, py"
      },
      {
        value: "C#",
        label: "C#",
        disabled: false,
        extension: "txt, cs"
      },
      {
        value: "C%2B%2B",
        label: "C++",
        disabled: false,
        extension: "txt, cpp, cc, cxx, h"
      },
      {
        value: "Rust",
        label: "Rust",
        disabled: false,
        extension: "txt, rs"
      },
      {
        value: "pyspark",
        label: "Pyspark",
        disabled: false,
        extension: "txt, py"
      },
      {
        value: "VB",
        label: "VB",
        disabled: false,
        extension: "txt, vb"
      },
      {
        value: "VB.NET",
        label: "VB.NET",
        disabled: false,
        extension: "txt, vb"
      },
      {
        value: "Power Builder",
        label: "Power Builder",
        disabled: false,
        extension: "txt, pbl, sra, sru, srw"
      },
      {
        value: "React",
        label: "React",
        disabled: false,
        extension: "txt, jsx, js, ts, tsx"
      },
      {
        value: "Angular",
        label: "Angular",
        disabled: false,
        extension: "txt, ts, html, css, scss"
      },
      {
        value: "MS Access",
        label: "MS Access",
        disabled: false,
        extension: "txt, accdb, mdb"
      }
    ]
  },
  {
    label: "Hyperscalers",
    options: [
      { value: "gcp", label: "GCP (Google Cloud Platform)" },
      { value: "aws", label: "AWS (Amazon Web Services)" },
      { value: "azure", label: "Azure" },
      { value: "onpremises", label: "On-premises" },
      { value: "ibm", label: "IBM Cloud" },
      { value: "oracle", label: "Oracle Cloud" },
      { value: "digitalOcean", label: "DigitalOcean" },
      { value: "heroku", label: "Heroku" },
      { value: "VMware", label: "VMware" },
      { value: "openStack", label: "OpenStack" },
      { value: "alibaba cloud", label: "Alibaba Cloud" },
      { value: "rackspace", label: "Rackspace" },
      { value: "salesforce", label: "Salesforce Platform" }
    ]
  }
];

export const modelOptions = [
  {
    value: "UST Code crafter llm",
    label: "UST Code crafter llm"
  },
  {
    value: "UST Code crafter llm pro",
    label: "UST Code crafter llm pro"
  },
  {
    value: "Llama3.3-finetuned",
    label: "Llama 3.3 Finetuned by UST",
  }
]